module.exports = __webpack_public_path__ + "static/media/Floor 1_worker.9fc070cd.svg";